import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const createStyles = (theme) =>
  StyleSheet.create({
    container: {
      backgroundColor: theme.footerBg || 'yellow',
      padding: 5,
      width: '100%',
    },
    row: {
      flexDirection: 'row',
    },
    w100: { width: '100%' },
    w50: { width: '50%' },
    storeDetails: {
      fontSize: theme.fontSize || 14,
      padding: 2,
    },
    storeName: {
      fontSize: theme.headerFontSize || 14,
      fontFamily: theme.fontFamily,
      color: theme.footerText || 'black',
    },
    storeAddress: {
      fontSize: theme.fontSize || 11,
      marginBottom: 3,
      fontFamily: theme.fontFamily,
      color: theme.footerText || 'black',
    },
    contactInfo: {
      paddingLeft: 80,
      margin: '0 auto',
    },
    pageInfo: {
      fontSize: theme.fontSize || 10,
      textAlign: 'center',
      marginTop: 5,
      fontFamily: theme.fontFamily,
      color: theme.footerText || 'black',
    },
  });

const FooterFour = ({ company, pageIndex, totalPages, theme }) => {
  const styles = createStyles(theme);
  return (
    <View style={styles.container}>
      <View style={[styles.row, styles.w100]}>
        <View style={[styles.w50, styles.storeDetails]}>
          <Text style={styles.storeName}>{company.name}</Text>
          <Text style={styles.storeAddress}>{company.addressLine1}</Text>
          <Text style={styles.storeAddress}>{company.addressLine2}</Text>
          <Text style={styles.storeAddress}>{company.addressLine3}</Text>
        </View>
        <View style={[styles.w50, styles.contactInfo]}>
          <Text style={styles.storeName}>Contact:</Text>
          <Text style={styles.storeAddress}>Ph: {company.phone}</Text>
          <Text style={styles.storeAddress}>Whatsapp: {company.whatsapp}</Text>
          <Text style={styles.storeAddress}>Mail: {company.email}</Text>
        </View>
      </View>
      <Text style={styles.pageInfo}>
        Page {pageIndex} of {totalPages}
      </Text>
    </View>
  );
};

export default FooterFour;